import React from 'react';
import { connect } from 'react-redux';
import { Typography, Grid, Box } from '@material-ui/core';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import { useTranslation } from 'react-i18next';
import VideoPc from '../../../../components/Video/VideoPc';
import { Button, InscriptionButton } from '../../../../components/Buttons';
import { InscriptionsContainer, StyledMessageButton, Title } from './styles';
import Animation from '../../../../components/Animation';
import { scrollToDirectorMessage } from '../../actions';
import Link from '../../../../components/Link';
import Promo from './PromoEN';

const Inscriptions = props => {
	const { t, i18n } = useTranslation();

	return (
		<InscriptionsContainer>
			<Grid container alignItems="center">
				{i18n.language === 'es' ? (
					<Grid item xs={12} md={5} className="data-grid">
						<Animation animateIn="fadeInLeft">
							<LabelTitle content={t('general.inscriptions.label')} />
							<Title variant="h1" color="textPrimary">
								{t('general.inscriptions.title')}
							</Title>
							<Typography variant="body1" color="textPrimary">
								{t('general.inscriptions.subtitle')}
							</Typography>
						</Animation>

						<Box mr={1.5} display={{ xs: 'none', md: 'inline' }}>
							<InscriptionButton />
						</Box>
						<Box display={{ xs: 'none', md: 'inline' }}>
							<StyledMessageButton
								content={t('general.actions.message')}
								variant={'outlined'}
								color={'primary'}
								onClick={props.scrollToDirectorMessage}
							/>
						</Box>
					</Grid>
				) : (
					<Promo scrollToDirectorMessage={props.scrollToDirectorMessage} />
				)}
				<Grid item xs={12} md={6}>
					<VideoPc
						src={
							i18n.language === 'es'
								? '/static/media/videos/demo-es.mp4'
								: '/static/media/videos/demo-en.mp4'
						}
					/>
					<Grid container direction="column" justify="center" alignItems="center">
						<Box display={{ xs: 'block', md: 'none' }} mb={1.5}>
							<InscriptionButton />
						</Box>
						<Link href={`/cursos/${i18n.language}/course_one/theme_example`}>
							<Button
								content={t('general.actions.tryMe')}
								variant={'contained'}
								color={'primary'}
							/>
						</Link>
					</Grid>
				</Grid>
			</Grid>
		</InscriptionsContainer>
	);
};

const mapStateToProps = state => {
	return {};
};

const mapDispatchToProps = dispatch => {
	return {
		scrollToDirectorMessage: payload => scrollToDirectorMessage(dispatch, payload)
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Inscriptions);
